import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1 className="page-title">About Me</h1>
      </div>
    </div>
  );
};

export default About;